import script from "./LogoSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoSetup.vue?vue&type=script&setup=true&lang=js"

import "./LogoSetup.vue?vue&type=style&index=0&id=287cfb1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-287cfb1a"]])

export default __exports__